/**
 * EventVendorSettingService
 * Service for managing event vendor settings
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event vendor setting CRUD operations
 */
export class EventVendorSettingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventVendorSettingService.DEFAULT_SERVICE_PATH,
            basePath: EventVendorSettingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EventVendorSettingService.DEFAULT_SERVICE_PATH = 'events';
EventVendorSettingService.BASE_PATH = 'api/event-vendor-settings';
//# sourceMappingURL=EventVendorSettingService.js.map